import { useMemo, useRef } from 'react'
import styles from './shareBlock.module.scss'
import Button from '../../UI/Button/Button'
import cn from 'classnames'
import { copyText } from '../../helpers/copyText.helper'
import { getLinks } from './config'
import { trackVacancyShare } from '../../utils/gtm'
import { ReactComponent as CloseIcon } from '../../assets/icons/close-accent-color.svg'
import UseSmartTooltip from '../../hooks/useSmartTooltip'

const ShareBlock = ({ slug, onClose, isOpen, isMobileView }) => {
  const textToCopyRef = useRef(null)

  const link = encodeURIComponent(`${window.location.origin}/vacancy/${slug}`)

  const links = useMemo(() => getLinks(slug), [slug])

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.wrapper_transparent]: !isOpen,
        [styles.wrapper_mobile]: isMobileView,
        [styles.wrapper_mobile_open]: isOpen && isMobileView,
        [styles.wrapper_opening]: isOpen && !isMobileView,
        [styles.wrapper_closing]: !isOpen && !isMobileView,
      })}
    >
      <Button theme='transparent' className={styles.close}>
        <CloseIcon stroke='#07251e' onClick={onClose} />
      </Button>
      <p>
        <b>Share</b>
      </p>
      <div
        className={cn(styles.networks_links, {
          [styles.networks_links_mobile]: isMobileView,
        })}
      >
        {links.map(
          ({ Icon, link }, index) =>
            Icon && (
              <a key={index} href={link} target='_blank' rel='noopener noreferrer'>
                <Icon className={styles.icon} />
              </a>
            )
        )}
      </div>
      <div className={styles.link}>
        <UseSmartTooltip className={styles.linkTooltip}>
          <span ref={textToCopyRef}>{decodeURIComponent(link)}</span>
        </UseSmartTooltip>
        <Button
          className={styles.shareBtn}
          onClick={() => {
            copyText(textToCopyRef)
            trackVacancyShare(decodeURIComponent(link))
          }}
          size={'middle-full'}
        >
          Copy
        </Button>
      </div>
    </div>
  )
}
export default ShareBlock
